"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgFileEmptyFilled = function SvgFileEmptyFilled(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    id: 'file-empty-filled_svg__a',
    d: 'M19.82 7.998H14V2.184c.293.146.625.417.996.813l4.007 4.006c.426.38.699.71.818.995zM20 9.99V20c0 1.333-.667 2-2 2H6.002C4.667 22 4 21.334 4 20V4c0-1.333.667-2 2-2h6v5.998c0 1.358.667 2.025 2 2 1.196-.023 3.196-.025 6-.007z'
  })), react_1.default.createElement("use", {
    xlinkHref: '#file-empty-filled_svg__a'
  }));
};

exports.default = SvgFileEmptyFilled;